export default "__VITE_ASSET__Bwb99tg9__"